module.exports = __webpack_public_path__ + "static/media/2015.1ca942bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/images/2015.jpg
// module id = 255
// module chunks = 0